import avatar from './anyone.png';
import type { Staff, StaffOption } from 'types/models';

export const ANYONE_ID = '0';

export const ANYONE: StaffOption = {
  avatar,
  // extraData is typed `Staff | undefined` in models.ts (owned elsewhere); this
  // sentinel genuinely has no staff record, so cast the existing `null` value.
  extraData: null as unknown as Staff | undefined,
  id: ANYONE_ID,
  name: 'Anyone',
};